import React from 'react';
import { Image, StyleSheet, View } from './base_components';

const FILM_ICON = require('../assets/img/film.svg');
const FOLDER_ICON = require('../assets/img/folder.svg');
const DOC_ICON = require('../assets/img/document.svg');

const MEDIA_REGEX = /(mov|mkv|mp4|mxf)$/;

const styles = StyleSheet.create({
  mediaIcon: {},
  iconImage: {
    flex: 1,
    alignSelf: 'stretch',
  },
});

type Props = {
  style?: any;
  isDir?: boolean;
  name: string;
};

export default class MediaIcon extends React.PureComponent<Props> {
  render() {
    const { style, isDir, name } = this.props;

    let img_src = null;
    if (isDir) {
      img_src = FOLDER_ICON;
    } else if (MEDIA_REGEX.test(name)) {
      img_src = FILM_ICON;
    } else {
      img_src = DOC_ICON;
    }

    return (
      <View style={[styles.mediaIcon, style]}>
        <Image style={styles.iconImage} source={img_src} />
      </View>
    );
  }
}
